export default __webpack_public_path__ + "static/116-e6ab7fb71b5dfb48fed2deeaf01fc5ec.jpg";